<template>
  <div :class="'app-forgot-password-wrapper ' + view" class="fill-yellow-gradient">
    <div class="composition-wrapper">
      <div class="card card--form">
        <ForgotPasswordInputMsisdn v-if="view === 'input'">
          <template v-for="slot in possibleChildSlotsFor('Msisdn')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ForgotPasswordInputMsisdn>
        <ForgotPasswordInputChannel
          v-if="view === 'channel'"
          :is-registration="isRegistration"
        >
          <template v-for="slot in possibleChildSlotsFor('Channel')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ForgotPasswordInputChannel>
        <ForgotPasswordInputError
          v-if="view === 'error'"
        >
          <template v-for="slot in possibleChildSlotsFor('Error')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ForgotPasswordInputError>
        <ForgotPasswordSucceeded v-if="view === 'succeeded'">
          <template v-for="slot in possibleChildSlotsFor('Email')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ForgotPasswordSucceeded>
        <ForgotPasswordToken
          :token-placeholder="tokenPlaceholder"
          v-if="view === 'token'">
          <template v-for="slot in possibleChildSlotsFor('Sms')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ForgotPasswordToken>
        <ResetPasswordConfirmationPassword
          v-if="view === 'password'"
          :success-link="successLink"
        >
          <template v-for="slot in possibleChildSlotsFor('Password')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ResetPasswordConfirmationPassword>
      </div>
      <div class="bottomLinks center" v-if="view !== 'token' && view !== 'succeeded'">
        <slot name="txtBottomLink"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import ForgotPasswordSucceeded from '@/components/process/generic/ForgotPassword/Succeeded.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import ForgotPasswordToken from '@/components/process/generic/ForgotPassword/Token.vue'
import ResetPasswordConfirmationPassword from '@/components/process/generic/ResetPasswordConfirmation/Password.vue'
import ForgotPasswordInputMsisdn from '@/components/process/generic/ForgotPassword/InputMsisdn.vue'
import ForgotPasswordInputChannel from '@/components/process/generic/ForgotPassword/InputChannel.vue'
import ForgotPasswordInputError from '@/components/process/generic/ForgotPassword/Error.vue'

export default {
  name: 'ForgotPasswordWrapper',
  created: function () {
    this.setView('input')
  },
  mixins: [
    transaction('forgotPassword')
  ],
  methods: {
    ...mapMutations('forgotPassword', [
      'setView'
    ])
  },
  computed: {
    ...mapGetters('forgotPassword', [
      'view'
    ]),
    inWebView () {
      return window.App !== undefined && window.App.reset !== undefined && window.App.refreshedToken !== undefined
    },
    isIosDevice () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  mounted () {
    const closeIcon = document.getElementById('mobile-close')
    const me = this
    if (closeIcon !== null && typeof closeIcon !== 'undefined') {
      closeIcon.addEventListener('click', function () {
        if (me.inWebView) {
          const message = 'back to login from forgot password page'
          if (me.isIosDevice) {
            window.webkit.messageHandlers.reset.postMessage(message)
          } else {
            window.App.reset(message)
          }
        }
      })
    }
  },
  components: {
    ForgotPasswordInputError,
    ForgotPasswordInputChannel,
    ForgotPasswordInputMsisdn,
    ResetPasswordConfirmationPassword,
    ForgotPasswordToken,
    ForgotPasswordSucceeded
  },
  props: {
    successLink: {
      type: String,
      default: '#'
    },
    msisdnPlaceholder: {
      type: String,
      default: '+49'
    },
    tokenPlaceholder: {
      type: String,
      default: 'Dein SMS-Code'
    },
    isRegistration: {
      type: Boolean,
      default: false
    }
  }
}
</script>
